import 'protons';
import './_about-us-video.scss';
import './_about-us-video.twig';
import './assets/about-us-video--animation.mp4';

export const name = 'about-us-video';

export const defaults = {};

export function disable() {}

export function enable() {}

export default enable;
